//@flow
import React from "react";
// $FlowFixMe
import css from "./listenagain.module.scss";
// import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
// import {faArrowCircleDown, faArrowRight} from '@fortawesome/free-solid-svg-icons';
type Props = {
  children: Array<Object>,
  display: boolean,
  showtag:string
};

export default class EpisodeList extends React.PureComponent<Props, *> {
  render(): Object {
    // const height = this.props.show
    //   ? this.props.children.length * 104 + "px"
    //   : "0";
    const height = this.props.display ? "600px" : "0";

    return (
      <div
        className={css.episodeList}
        style={{
          maxHeight: height,
        }}
      >
        {this.props.children}
       
        <a className={css.more} target="_blank" rel="noopener noreferrer" href={`https://indemandradio.com/shows/${this.props.showtag}`} onClick={(e) => e.stopPropagation()}>
          View on website&nbsp;<i className="fa fa-external-link-alt" />
        </a>
      </div>
    );
  }
}
